import {useCallback,useEffect,useRef,useState} from 'react';
import './panelOutlineIntro.css';

/** A once-per-board-visit hint, independent of the player's inspection toggle. */
export function usePanelOutlineIntro({ready,blocked,editing}:{ready:boolean;blocked:boolean;editing:boolean}){
  const consumed=useRef(false);
  const [visible,setVisible]=useState(false);
  const cancel=useCallback(()=>{consumed.current=true;setVisible(false);},[]);

  useEffect(()=>{
    if(editing){cancel();return;}
    if(!ready||blocked||consumed.current)return;
    const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
    let start:ReturnType<typeof setTimeout>|undefined;
    let finish:ReturnType<typeof setTimeout>|undefined;
    const clear=()=>{clearTimeout(start);clearTimeout(finish);};
    const stop=()=>{clear();cancel();};
    const schedule=()=>{
      clear();
      if(motion.matches){stop();return;}
      if(consumed.current||document.hidden)return;
      start=setTimeout(()=>{
        if(consumed.current||document.hidden||motion.matches)return;
        consumed.current=true;
        setVisible(true);
        finish=setTimeout(()=>setVisible(false),770);
      },150);
    };
    const visibility=()=>{
      if(document.hidden){clear();if(consumed.current)cancel();}
      else schedule();
    };
    const preference=()=>{if(motion.matches)stop();};
    document.addEventListener('visibilitychange',visibility);
    motion.addEventListener('change',preference);
    schedule();
    return()=>{
      clear();setVisible(false);
      document.removeEventListener('visibilitychange',visibility);
      motion.removeEventListener('change',preference);
    };
  },[ready,blocked,editing,cancel]);

  return {visible:visible&&ready&&!blocked&&!editing,cancel};
}
